// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zUQMUN {
  padding: 0;
  background: transparent;
  width: 100%;
}

.yE90lM {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 28.0625rem;
  gap: var(--spacing-3);
  align-items: stretch;
}

@media (max-width: 900px) {
  .yE90lM {
    grid-template-columns: 1fr;
  }
}

.NajTb0 {
  position: relative;
  border-radius: var(--card-border-radius);
  overflow: hidden;
  min-height: 18rem;
  min-width: 0;
}

.e1cMoI {
  width: 100%;
  height: 100%;
  min-height: 18rem;
  object-fit: cover;
  display: block;
}

.fU5vlT {
  position: absolute;
  left: -21%;
  top: -38%;
  width: 145%;
  height: auto;
  max-width: none;
  pointer-events: none;
}

.YQGdse {
  background: var(--surface-neutral-subtle);
  border-radius: var(--card-border-radius);
  padding: var(--spacing-4) var(--spacing-5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--spacing-3);
  align-self: stretch;
  min-width: 0;
}

.qO94Iq {
  margin: 0;
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-medium);
  line-height: 100%;
  color: var(--text-neutral-dark);
  font-family: var(--font-family-clario), var(--font-family-base);
  text-align: left;
  align-self: stretch;
}

.xY7UcF {
  display: block;
  font-weight: var(--font-weight-bold);
  color: var(--brand-tr-orange);
}

.UI_M1D {
  display: block;
  font-weight: var(--font-weight-medium);
}

.kMsuW3 {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  align-self: stretch;
}

.wqwTJA {
  display: flex;
  gap: var(--spacing-1-5);
  align-items: center;
  min-width: 0;
}

.ysrhMb {
  padding-bottom: var(--spacing-3);
}

.YXWhqs {
  flex-shrink: 0;
  display: inline-flex;
  width: 1.34375rem;
  height: 1.34375rem;
  align-items: center;
  justify-content: center;
}

.YXWhqs img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.l7Mm4v {
  flex: 1;
  min-width: 0;
  font-size: var(--font-size-lg, 16px);
  line-height: 1;
  font-weight: var(--font-weight-regular);
  color: #000000;
  font-family: var(--font-family-base);
  text-align: left;
}

.l7Mm4v .bd3lXf {
  font-size: var(--font-size-lg);
  line-height: 0;
  vertical-align: middle;
  margin-left: 0.125rem;
}

.xUSlWU {
  border: none;
  background: none;
  padding: 0;
  cursor: help;
  display: inline-flex;
  vertical-align: middle;
}

.xUSlWU > span {
  transform: scale(0.75);
  transform-origin: center;
}

.R3WDpi {
  width: 100%;
  align-self: stretch;
  box-sizing: border-box;
}

.R3WDpi.R3WDpi {
  padding-block: 0.625rem !important;
  padding-inline: var(--spacing-1-5) !important;
  line-height: 1 !important;
  font-weight: var(--font-weight-medium) !important;
}

.Eo9jlT {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--spacing-3);
  margin-top: var(--spacing-7);
  width: 100%;
  box-sizing: border-box;
}

.WOTr4u {
  grid-template-columns: minmax(0, 1fr);
}

@media (max-width: 700px) {
  .Eo9jlT {
    grid-template-columns: 1fr;
  }
}

.crpkxe {
  background: #f8eadd;
  border-radius: var(--card-border-radius);
  padding: var(--spacing-3);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--spacing-3);
  box-sizing: border-box;
}

.LHiDP2 {
  background: var(--surface-neutral-subtle);
  border-radius: var(--card-border-radius);
  padding: var(--spacing-3);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--spacing-3);
  box-sizing: border-box;
}

.u5r4co {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  gap: var(--spacing-1-5);
}

.Br898_ {
  display: inline-flex;
  width: 1.34375rem;
  height: 1.34375rem;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.Br898_ img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.lOED5j {
  margin: 0;
  font-size: var(--font-size-lg);
  line-height: var(--line-height-160);
  font-weight: var(--font-weight-regular);
  font-family: var(--font-family-base);
  width: 100%;
}

.crpkxe .lOED5j {
  color: #000000;
}

.LHiDP2 .lOED5j {
  color: var(--text-neutral-dark);
}

.IAUYQ4 {
  width: 100%;
  align-self: stretch;
  box-sizing: border-box;
}

.IAUYQ4.IAUYQ4 {
  padding-block: 0.625rem !important;
  padding-inline: var(--spacing-1-5) !important;
  line-height: 1 !important;
  font-weight: var(--font-weight-medium) !important;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/InsideSalesBenefitsLanding/components/InsideSalesHiringStepsSection/InsideSalesHiringStepsSection.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,wCAAwC;EACxC,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,sCAAsC;EACtC,iBAAiB;EACjB,+BAA+B;EAC/B,+DAA+D;EAC/D,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,uCAAuC;EACvC,cAAc;EACd,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;EAC7C,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,qBAAqB;EACrB,4BAA4B;EAC5B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,uCAAuC;EACvC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;EAC7C,yBAAyB;EACzB,iDAAiD;AACnD","sourcesContent":[".section {\n  padding: 0;\n  background: transparent;\n  width: 100%;\n}\n\n.topBlock {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 28.0625rem;\n  gap: var(--spacing-3);\n  align-items: stretch;\n}\n\n@media (max-width: 900px) {\n  .topBlock {\n    grid-template-columns: 1fr;\n  }\n}\n\n.photo {\n  position: relative;\n  border-radius: var(--card-border-radius);\n  overflow: hidden;\n  min-height: 18rem;\n  min-width: 0;\n}\n\n.photoImg {\n  width: 100%;\n  height: 100%;\n  min-height: 18rem;\n  object-fit: cover;\n  display: block;\n}\n\n.photoWaypoint {\n  position: absolute;\n  left: -21%;\n  top: -38%;\n  width: 145%;\n  height: auto;\n  max-width: none;\n  pointer-events: none;\n}\n\n.card {\n  background: var(--surface-neutral-subtle);\n  border-radius: var(--card-border-radius);\n  padding: var(--spacing-4) var(--spacing-5);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: var(--spacing-3);\n  align-self: stretch;\n  min-width: 0;\n}\n\n.title {\n  margin: 0;\n  font-size: var(--font-size-3xl);\n  font-weight: var(--font-weight-medium);\n  line-height: 100%;\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-clario), var(--font-family-base);\n  text-align: left;\n  align-self: stretch;\n}\n\n.titleLead {\n  display: block;\n  font-weight: var(--font-weight-bold);\n  color: var(--brand-tr-orange);\n}\n\n.titleRest {\n  display: block;\n  font-weight: var(--font-weight-medium);\n}\n\n.steps {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  align-self: stretch;\n}\n\n.step {\n  display: flex;\n  gap: var(--spacing-1-5);\n  align-items: center;\n  min-width: 0;\n}\n\n.stepLast {\n  padding-bottom: var(--spacing-3);\n}\n\n.stepArrowWrap {\n  flex-shrink: 0;\n  display: inline-flex;\n  width: 1.34375rem;\n  height: 1.34375rem;\n  align-items: center;\n  justify-content: center;\n}\n\n.stepArrowWrap img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.stepText {\n  flex: 1;\n  min-width: 0;\n  font-size: var(--font-size-lg, 16px);\n  line-height: 1;\n  font-weight: var(--font-weight-regular);\n  color: #000000;\n  font-family: var(--font-family-base);\n  text-align: left;\n}\n\n.stepText .stepActivationTooltipTrigger {\n  font-size: var(--font-size-lg);\n  line-height: 0;\n  vertical-align: middle;\n  margin-left: 0.125rem;\n}\n\n.stepInfo {\n  border: none;\n  background: none;\n  padding: 0;\n  cursor: help;\n  display: inline-flex;\n  vertical-align: middle;\n}\n\n.stepInfo > span {\n  transform: scale(0.75);\n  transform-origin: center;\n}\n\n.startCta {\n  width: 100%;\n  align-self: stretch;\n  box-sizing: border-box;\n}\n\n.startCta.startCta {\n  padding-block: 0.625rem !important;\n  padding-inline: var(--spacing-1-5) !important;\n  line-height: 1 !important;\n  font-weight: var(--font-weight-medium) !important;\n}\n\n.actionRow {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--spacing-3);\n  margin-top: var(--spacing-7);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.actionRowSingle {\n  grid-template-columns: minmax(0, 1fr);\n}\n\n@media (max-width: 700px) {\n  .actionRow {\n    grid-template-columns: 1fr;\n  }\n}\n\n.actionCardSales {\n  background: #f8eadd;\n  border-radius: var(--card-border-radius);\n  padding: var(--spacing-3);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: var(--spacing-3);\n  box-sizing: border-box;\n}\n\n.actionCardInvite {\n  background: var(--surface-neutral-subtle);\n  border-radius: var(--card-border-radius);\n  padding: var(--spacing-3);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: var(--spacing-3);\n  box-sizing: border-box;\n}\n\n.actionCardBody {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-self: stretch;\n  gap: var(--spacing-1-5);\n}\n\n.actionIconSlot {\n  display: inline-flex;\n  width: 1.34375rem;\n  height: 1.34375rem;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.actionIconSlot img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.actionText {\n  margin: 0;\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-160);\n  font-weight: var(--font-weight-regular);\n  font-family: var(--font-family-base);\n  width: 100%;\n}\n\n.actionCardSales .actionText {\n  color: #000000;\n}\n\n.actionCardInvite .actionText {\n  color: var(--text-neutral-dark);\n}\n\n.actionCta {\n  width: 100%;\n  align-self: stretch;\n  box-sizing: border-box;\n}\n\n.actionCta.actionCta {\n  padding-block: 0.625rem !important;\n  padding-inline: var(--spacing-1-5) !important;\n  line-height: 1 !important;\n  font-weight: var(--font-weight-medium) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `zUQMUN`,
	"topBlock": `yE90lM`,
	"photo": `NajTb0`,
	"photoImg": `e1cMoI`,
	"photoWaypoint": `fU5vlT`,
	"card": `YQGdse`,
	"title": `qO94Iq`,
	"titleLead": `xY7UcF`,
	"titleRest": `UI_M1D`,
	"steps": `kMsuW3`,
	"step": `wqwTJA`,
	"stepLast": `ysrhMb`,
	"stepArrowWrap": `YXWhqs`,
	"stepText": `l7Mm4v`,
	"stepActivationTooltipTrigger": `bd3lXf`,
	"stepInfo": `xUSlWU`,
	"startCta": `R3WDpi`,
	"actionRow": `Eo9jlT`,
	"actionRowSingle": `WOTr4u`,
	"actionCardSales": `crpkxe`,
	"actionCardInvite": `LHiDP2`,
	"actionCardBody": `u5r4co`,
	"actionIconSlot": `Br898_`,
	"actionText": `lOED5j`,
	"actionCta": `IAUYQ4`
};
module.exports = ___CSS_LOADER_EXPORT___;
